import styled from 'styled-components'
import { slideOutDown, slideInAndOut, fadeInAndOut, fadeIn } from './animations'

export type ShieldProps = {
  variant?: 'upAndDown' | 'down'
}

export const Container = styled.div<ShieldProps>`
  position: absolute;
  left: 0;
  top: 100%;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 30;

  ${({ variant }) => (variant === 'upAndDown' ? slideInAndOut : slideOutDown)}
`

export const IconWrapper = styled.div<ShieldProps>`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  /* TODO: get color from Burst in global styles too */
  background-color: ${({ theme }) => theme.color.oceanSidebar};

  > svg {
    width: 17%;

    ${({ variant }) => variant === 'upAndDown' && fadeIn}

    > path {
      fill: ${({ theme }) => theme.color.ocean};
    }
  }
`

export const Overlay = styled.div<ShieldProps>`
  background-color: ${({ theme }) => theme.color.oceanDark};
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 29;
  opacity: 0;
  pointer-events: none;

  ${({ variant }) => variant === 'upAndDown' && fadeInAndOut}
`
